import { CreditCardIcon, XCircleIcon } from '@heroicons/react/20/solid';
import { NavLink, redirect, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from "react";
import StorageService from "../services/storage-service";
import NovelsService from "../services/novels-service";
import { auth } from "../firebase-config";
import axios from "axios";
import PaymentService from "../services/payment-service";

import $ from "jquery";


export default function BuyNovel() {

    const navigate = useNavigate();

    const [image, setImage] = useState("");
    const [novel, setNovel] = useState(null);
    const [user, setUser] = useState(auth.currentUser);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("")
    const [contact, setContact] = useState("");
    const [address, setAddress] = useState("");
    const [amount, setAmount] = useState("");
    const [currency, setCurrency] = useState("");

    const params = useParams();
    const novelId = params.novelId;

    useEffect(() => {
        if (!user) {
            navigate("/login");
        }
        else {
            setEmail(user.email);
        }

        NovelsService.getNovel(novelId)
            .then((novel) => {
                setNovel(novel);
                if (Intl.DateTimeFormat().resolvedOptions().timeZone === "Asia/Colombo") {
                    setAmount(novel.local_price);
                    setCurrency("LKR");
                }
                else {
                    setAmount(novel.usd_price);
                    setCurrency("USD");
                }

            });
    }, []);

    useEffect(() => {
        StorageService.getThumbnail(novelId)
            .then((image) => {
                setImage(image);
            });
    }, [image, user, email]);


    function contactSubmit(e) {
        e.preventDefault();

        if (handleValidation()) {
            alert("Form submitted");
        } else {
            alert("Form has errors.")
        }
    }

    function handleValidation() {
        return true;
    }
    async function payNow(e) {

        const app_id = 'KCRD11907F49F0AAA1846';
        const salt = "H9RC11907F49F0AAA186B";

        const app_token = "fd8346f5ae9fe260347f008d3f9d89c0419f0aa606ea0540da012243c33ec09ffc62b6c562359bdf.D9V711907F49F0AAA1880";

        const concatenated = app_id + currency + amount.toFixed(2) + salt;

        const encoder = new TextEncoder();
        const data = encoder.encode(concatenated);

        // Hash the data using SHA-256
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);

        // Convert the hash to a hexadecimal string
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');

        console.log(hashHex);
        console.log(concatenated);

        const min = 1;
        const max = 100;
        const rand = min + Math.random() * (max - min);


        let price = amount;
        let order_id = rand;
        let text = order_id + '|' + price;
        console.log(text);

        const config = {
            headers: {
                Authorization: app_token,
                'Content-Type': 'application/json'
            }
        };

        axios.post('https://api.onepay.lk/v3/checkout/link/', {
            "currency": "LKR",
            "app_id": app_id,
            "hash": hashHex,
            "amount": amount.toFixed(2),
            "reference": lastName,
            "customer_first_name": firstName,
            "customer_last_name": lastName,
            "customer_phone_number": contact,
            "customer_email": email,
            "transaction_redirect_url": "https://sayurabooks.app/verify-payment/"+user.uid + novelId + "/" + user.uid,
            "additionalData": user.uid,
        }, config)
            .then(response => {
                console.log(response.data);
                if (response.status === 200) {
                    // Redirect to the URL provided in the response
                    console.log(response.data.data.gateway.redirect_url);
                    console.log(response.data.data.ipg_transaction_id);

                    let order = {
                        orderId: user.uid + novelId,
                        userId: user.uid,
                        novelId: novelId,
                        firstName: firstName,
                        lastName: lastName,
                        email: email,
                        contact: contact,
                        address: address,
                        amount: amount,
                        currency: currency,
                        transaction_id: response.data.data.ipg_transaction_id,
                        timestamp: Date.now()
                    }
                    
                    PaymentService.addOrder(order).then((res) => {
                        console.log(res);

                        if (res) {
                            // alert("Order added successfully");
                            console.log("Order added successfully");
                            // navigate("/read-novel/" + novelId);
                            console.log("User ID: " + user.uid);

                            window.location.href = response.data.data.gateway.redirect_url;
                        } else {
                            alert("Error adding order");
                        }


                    });
                  }
            })
            .catch(error => {
                console.error(error);
            });


        

        // client.post('', {
        //     first_name: firstName,
        //     last_name: lastName,
        //     email: email,
        //     contact_number: contact,
        //     address_line_one: address,
        //     process_currency: 'LKR',
        //     secret_key: '9072d2b4-5888-4eaf-b3a0-13ba15c8843b',
        //     custom_fields : '',
        //     payment: encrypted
        // })
        //     .then((response) => {
        //         console.log(response);
        //     });




    }


    return (
        <>
            <div className="flex min-h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
                <div className="w-full max-w-md space-y-8">
                    <div>
                        <img
                            className="mx-auto h-24 w-auto"
                            src={require("../images/logo.png")}
                            alt="GanagaShinie Novels"
                        />

                        <div className="grid grid-cols-2 gap-4 my-8">
                            <div className="flex justify-center">
                                <img src={image} alt="Loading" />
                            </div>
                            <div className="container mx-auto">
                                {novel ?
                                    <>
                                        <h1 className="mt-6 text-center text-3xl tracking-tight text-gray-500">{novel.title}</h1>
                                        <h2 className="mt-6 text-center text-xl tracking-tight text-gray-500">{novel.author}</h2>
                                        {Intl.DateTimeFormat().resolvedOptions().timeZone === "Asia/Colombo" ?
                                            <h2 className="mt-6 text-center text-xl tracking-tight text-red-500">{novel.local_price.toFixed(2)} /- LKR</h2> :
                                            <h2 className="mt-6 text-center text-xl tracking-tight text-red-500"> {novel.usd_price.toFixed(2)} /- USD</h2>}
                                    </> : ""}
                            </div>
                        </div>

                    </div>
                    <div className="mt-8 space-y-6">
                        <input type="hidden" name="remember" defaultValue="true" />
                        <div className="-space-y-px rounded-md shadow-sm">
                            <div>
                                <label htmlFor="first-name" className="sr-only">
                                    First name
                                </label>
                                <input
                                    id="first-name"
                                    name="first-name"
                                    type="text"
                                    autoComplete="first-name"
                                    required
                                    className="relative block w-full appearance-none rounded border border-gray-300 my-3 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-orange-500 focus:outline-none focus:ring-orange-500 sm:text-sm"
                                    placeholder="First name"
                                    value={firstName}
                                    onChange={(e) => { setFirstName(e.target.value) }}
                                />
                            </div>
                            <div>
                                <label htmlFor="last-name" className="sr-only">
                                    Last name
                                </label>
                                <input
                                    id="last-name"
                                    name="last-name"
                                    type="text"
                                    autoComplete="last-name"
                                    required
                                    className="relative block w-full appearance-none rounded border border-gray-300 my-3 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-orange-500 focus:outline-none focus:ring-orange-500 sm:text-sm"
                                    placeholder="Last name"
                                    value={lastName}
                                    onChange={(e) => { setLastName(e.target.value) }}
                                />
                            </div>

                            <div>
                                <label htmlFor="email-address" className="sr-only">
                                    Email
                                </label>
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    required
                                    className="relative block w-full appearance-none rounded border border-gray-300 my-3 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-orange-500 focus:outline-none focus:ring-orange-500 sm:text-sm"
                                    placeholder="Email"
                                    value={email}
                                    disabled
                                />
                            </div>

                            <div>
                                <label htmlFor="telephone" className="sr-only">
                                    Contact
                                </label>
                                <input
                                    id="contact"
                                    name="contact"
                                    type="tel"
                                    autoComplete="contact"
                                    required
                                    className="relative block w-full appearance-none rounded border border-gray-300 my-3 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-orange-500 focus:outline-none focus:ring-orange-500 sm:text-sm"
                                    placeholder="Contact"
                                    value={contact}
                                    onChange={(e) => { setContact(e.target.value) }}
                                />
                            </div>

                            <div>
                                <label htmlFor="address" className="sr-only">
                                    Address
                                </label>
                                <input
                                    id="address"
                                    name="address"
                                    type="text"
                                    autoComplete="address"
                                    required
                                    className="relative block w-full appearance-none rounded border border-gray-300 my-3 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-orange-500 focus:outline-none focus:ring-orange-500 sm:text-sm"
                                    placeholder="Address"
                                    value={address}
                                    onChange={(e) => { setAddress(e.target.value) }}
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-3 gap-4">
                            <button
                                type="button"
                                className="group relative flex w-full justify-center rounded-md border border-transparent bg-orange-500 py-2 px-4 text-sm font-medium text-white hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-2"
                                onClick={() => { navigate(-1) }}
                            >
                                <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                                    <XCircleIcon className="h-5 w-5 text-orange-300 group-hover:text-orange-400" aria-hidden="true" />
                                </span>
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="group relative flex col-span-2 w-full justify-center rounded-md border border-transparent bg-orange-500 py-2 px-4 text-sm font-medium text-white hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-2"
                                onClick={payNow}
                            >
                                <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                                    <CreditCardIcon className="h-5 w-5 text-orange-300 group-hover:text-orange-400" aria-hidden="true" />
                                </span>
                                Pay Now
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="something"></div>
        </>
    )
}